// src/pages/Home.jsx
import HeroSection from "../../../components/WomenFacultyMeet/herosection/herosection";
import "./about.css";

export default function Home({ PNG }) {
  return (
    <main className="home">
      {/* Hero */}
      <HeroSection title="About IWFM" image={PNG.WomenFaculty} />

      {/* About row */}
      <section className="about-row" aria-labelledby="about-iwfm-title">
        {/* <img
          src={PNG.WomenPoster}
          alt="Inaugural IIT Women Faculty Meet poster"
          className="about-image"
          loading="lazy"
        /> */}

        <div className="about-copy">
          <h3 id="about-iwfm-title" className="about-title">
            About IWFM
          </h3>
          <p className="about-text">
            As IITs grow and enter a new epoch of researching and doing science
            and engineering, a salient question ahead of them is not just about
            the kind of innovations and technologies they can advance, but about
            the people who drive them: is the learning, teaching, and research
            at IIT representative of the social world they ultimately exist in,
            and contribute to? The value of diversity in and to science is well
            established; as people from more diverse backgrounds join the
            institutes, one needs to think ahead about how to make the best use
            of their talents for inclusive science and technology. Adequate
            representation at all levels allows the institutes to understand how
            to shape campuses, policies, processes, and practices that allow
            everyone to flourish and contribute to problem-solving for a
            fast-changing world.
          </p>
        </div>
      </section>

      {/* Extended copy */}
      <section className="about-extended">
        <p>
          The female faculty meeting aims to create a supportive, vocal platform
          to drive institutional improvements and to influence institutional
          policy through formal recommendations.
        </p>

        <p>
          The meeting is a critical moment of reflection and deliberation in
          this regard: bringing women from IITs around the table to discuss what
          defines, limits, and can nurture and enrich their experiences and work
          at different IITs. It hopes to ask questions, but also provide answers
          to some pressing problems, paving the way for a STEM that includes,
          foregrounds, and moves with the reality of increasing numbers of women
          entering the IITs as students, faculty, and scientific staff. The
          gender equity self-assessment that was conducted in several IITs under
          the GATI (Gender Advancement for Transforming Institutions) project,
          spearheaded by DST, identified several important areas in which steps
          could be undertaken to enhance greater inclusion of women in STEM
          institutions.
        </p>
      </section>
    </main>
  );
}
